import { createRemoteReducer, RemoteReducer } from "types/Remote"
import { CustomTag } from "types/Template"

export const customTagReducer: RemoteReducer<CustomTag[]> =
  createRemoteReducer("customTag")
